import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSubscriptionPlan } from '../hooks/useSubscriptionPlan';
import { subscriptionPlanApi } from '../services/api';
import { Crown } from 'iconoir-react';
import '../styles/ads.css';

export const PremiumUpgradeBanner: React.FC = () => {
  const { isFreePlan, loading } = useSubscriptionPlan();
  const navigate = useNavigate();
  const [premiumPlanId, setPremiumPlanId] = useState<number | null>(null);

  useEffect(() => {
    if (!isFreePlan) return;
    // Pré-charger le plan premium le moins cher pour pouvoir y rediriger au clic.
    subscriptionPlanApi
      .getAll()
      .then((res) => {
        const paidPlans = res.data.plans.filter((p) => !p.has_ads);
        if (paidPlans.length > 0) {
          const cheapest = paidPlans.reduce((a, b) =>
            parseFloat(String(a.price_monthly)) < parseFloat(String(b.price_monthly)) ? a : b
          );
          setPremiumPlanId(cheapest.id);
        }
      })
      .catch(() => {
        // Silencieux : si le call rate, le bouton restera désactivé.
      });
  }, [isFreePlan]);

  if (loading || !isFreePlan) {
    return null;
  }

  const handleUpgrade = () => {
    if (!premiumPlanId) return;
    navigate('/upgrade-plan', {
      state: { planId: premiumPlanId, billingPeriod: 'monthly' },
    });
  };

  return (
    <div className="premium-upgrade-banner">
      <div>
        <h4>
          <Crown width={20} height={20} style={{ display: 'inline', marginRight: '8px' }} />
          Passez au Premium
        </h4>
        <p>Profitez de Ventilio sans publicité pour seulement 1,50€/mois</p>
      </div>
      <button
        type="button"
        className="btn-upgrade"
        onClick={handleUpgrade}
        disabled={!premiumPlanId}
      >
        Passer au Premium
      </button>
    </div>
  );
};
